import { IUser } from 'redux/store/user/types'
import { LedByUnion, StatusUnion } from '../types'

export const isOwnerCondition = (user: IUser) => ({
  'owner.uuid': user.uuid
})

export const isOwnerInSameHSCondition = (user: IUser) => ({
  'owner.health_system.uuid': user.health_system
})

export const isNotInLedBy = (inLedBY: LedByUnion[]) => ({
  led_by: {
    $nin: inLedBY
  }
})

export const isNotInStatuses = (inStatuses: StatusUnion[]) => ({
  status: {
    $nin: inStatuses
  }
})

export const isInStatuses = (inStatuses: StatusUnion[]) => ({
  status: {
    $in: inStatuses
  }
})

export const isManualContractCategory = () => ({
  is_manual: true
})

export const isAutoContractCategory = () => ({
  is_manual: false
})
